import React, {useRef} from "react";

const FileUploader = ({setFile, placeholder, multiple, acceptedFiles}) => {

    const inputRef = useRef();

    // const handleFileChange = (event) => {
    //     setFile(event.target.files[0]);
    // };

    const handleFileChange = (event) => {
        const newSelectedFiles = [...event.target.files]; // Convert FileList to an array

        if (multiple) {
            setFile(newSelectedFiles);
        } else {
            setFile(newSelectedFiles[0]);
        }
    };

    return (
        <>
            <input
                ref={inputRef}
                id="fileInput"
                type="file"
                style={{display: "none"}}
                onChange={handleFileChange}
                multiple={multiple}
                accept={acceptedFiles ?? "*/*"}
            />
            <label className="fileLabel" htmlFor="fileInput">
                <input
                    type="text"
                    placeholder={placeholder}
                    readOnly
                    onClick={() => inputRef.current.click()}
                    className="form-input"
                />

                <span><img src="/Images/upload.png" alt=""/></span>
            </label>
        </>
    );
};

export default FileUploader;